export const WarehouseClasses = 'form-col w-70';
export const CityClasses = 'form-col w-30';
export const StreetClasses = 'form-col w-50';
